import React, { useEffect, useRef } from 'react';

function ReservaRedirect({ sessionData, paqueteIdExterno, onComplete }) {
  useEffect(() => {
    if (sessionData && sessionData.redirectUrl) {
      console.log('═══════════════════════════════════════');
      console.log('🚀 INICIANDO PROCESO DE RESERVA CON SESSION');
      console.log('═══════════════════════════════════════');
      console.log('📊 SESSION creada en PHP con:');
      console.log('   username:', sessionData.username);
      console.log('   email:', sessionData.email);
      console.log('   nombre:', sessionData.nombre);
      console.log('   token:', sessionData.token);
      console.log('═══════════════════════════════════════');
      console.log('🔗 Redirigiendo a:', sessionData.redirectUrl);
      console.log('⏳ Redireccionando en 1.5 segundos...');
      
      // Redirigir a la URL de reservas
      // La SESSION ya está creada en PHP, así que no necesitamos pasar datos
      const timer = setTimeout(() => {
        console.log('✅ REDIRIGIENDO AHORA...');
        window.location.href = sessionData.redirectUrl;
        
        if (onComplete) {
          onComplete();
        }
      }, 1500);
      
      return () => clearTimeout(timer);
    }
  }, [sessionData, onComplete]);
  
  if (!sessionData) {
    console.log('❌ No hay sessionData disponible');
    return null;
  }
  
  return (
    <>
      {/* Overlay con mensaje de carga */}
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
        <div className="bg-white rounded-lg p-8 max-w-md shadow-2xl">
          <div className="text-center">
            {/* Spinner animado */}
            <div className="animate-spin rounded-full h-16 w-16 border-b-4 border-[#2AA8B0] mx-auto mb-4"></div>
            
            <h3 className="text-xl font-bold text-gray-900 mb-2">
              Redirigiendo a Reservas...
            </h3>
            <p className="text-gray-600 mb-4">
              Por favor espera mientras te llevamos al sistema de reservas.
            </p>
            
            {/* Información adicional */}
            <div className="bg-gray-50 rounded-lg p-4 text-left text-sm">
              <p className="text-gray-700">
                <span className="font-semibold">Usuario:</span> {sessionData.nombre} {sessionData.apellido}
              </p>
              <p className="text-gray-700">
                <span className="font-semibold">Email:</span> {sessionData.email}
              </p>
            </div>
            
            <p className="text-xs text-gray-500 mt-4">
              Si no eres redirigido automáticamente, por favor contacta a soporte.
            </p>
          </div>
        </div>
      </div>
    </>
  );
}

export default ReservaRedirect;